module.exports = __webpack_public_path__ + "static/media/fail.bd05922.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fail.mp3
// module id = 1142
// module chunks = 4 5 6 7